import { HybridCloudService } from '@qdrant/qdrant-cloud-public-api/hybrid/v1';
import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { assertRpcPermissions } from '@/api/permissions';
import { head } from '@/router/Head';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/configuration',
)({
  staticData: {
    title: ['Hybrid Cloud Environment', 'Configuration'],
  },
  beforeLoad: ({ context: { queryClient }, params: { accountId } }) => {
    assertRpcPermissions([HybridCloudService.method.updateHybridCloudEnvironment], { queryClient, accountId });
  },
  head,
  component: lazyRouteComponent(() => import('./configuration.component'), 'HybridCloudEnvConfigurationComponent'),
  pendingComponent: lazyRouteComponent(
    () => import('@/components/HybridCloudEnvironments/ConfigurationTab/ConfigurationTabSkeleton'),
    'HybridCloudEnvConfigurationSkeleton',
  ),
});
